import { isNotEmpty } from '@helpers'
import { FILTERS_DIRTY_TYPES, FILTERS_SA_TYPE, ValueType } from '@constants'

export const checkDirtyStoredValue = (value: ValueType, searchRule: FILTERS_SA_TYPE) => {
  const isValueNotEmpty = isNotEmpty(value)
  const isDirtyType = FILTERS_DIRTY_TYPES.includes(searchRule)

  // Для правил, которые требуют значения - показываем чип только если есть значение
  // Для правил EMPTY и NOT_EMPTY - показываем чип только если значение пустое
  let result = false

  if (isDirtyType) {
    // Правила, которые требуют значения (EQUAL, CONTAIN, etc.)
    result = isValueNotEmpty
  } else if (searchRule === 'EMPTY' || searchRule === 'NOT_EMPTY') {
    // Для EMPTY и NOT_EMPTY показываем чип только при пустом значении
    result = !isValueNotEmpty
  } else {
    // Для остальных правил (если есть) - показываем только при наличии значения
    result = isValueNotEmpty
  }

  return result
}
